<template>
  <section class="profile-content">
    <div class="left" :class="{ 'left_full': ctfMode == 'users' }">
      <div class="first">
        <div v-if="ctfMode == 'teams'" class="user-name">
           <span class="img"></span>
           <span class="name" :title="profile.uid">{{profile.uid}}</span>
        </div>
        <div v-if="ctfMode == 'users'" class="user-logo">
          <form id="logo_upload" action="/api/upload_logo" method="POST" enctype="multipart/form-data" ref="imgForm">
            <div class="logo_box">
              <img id="logo" :src="logoUrl" alt="" />
              <input type="file" name="logo" @change="submit"/>
            </div>
          </form>
        </div>
        <div class="user-info">
            <div class="Email">
              <span>Email: </span>{{profile.email}}
            </div>
            <div class="score">
              <span>Points：</span>{{score}}
            </div>
        </div>
      </div>
      <div class="second">
        <span>Solved Challenges</span>
        <ul class="table">
          <li class="thead">
            <a>
              <span>{{name_}}</span>
              <span>{{score_}}</span>
              <span>{{time_}}</span>
            </a>
          </li>
          <li class="tr" v-for="(r,index) in result" :key='index'>
            <router-link :to="r.pid && '/challenge/'+r.pid || ''">
              <span>{{r.title}}</span>
              <span>{{r.score}}</span>
              <span>{{formatTime(r.timestamp)}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="ctfMode == 'teams'" class="right">
      <div class="first hasTeam" v-if="isTeam">

        <div class="team-rate">
          <div>Ranking: <i>{{rank}}/{{total_teams}}</i></div>
          <div>Points: <i>{{score}}</i></div>
        </div>
        <div class="progress">
          <div class="progress-bar" :style="{width: percentage + '%'}"></div>
        </div>
        <div class="team-question">
          {{solved}}<i>{{solved_}}</i><i>/</i>{{challengeCount}}<i>{{total_}}</i>
        </div>
        <div class="team-button">
           <router-link to="/team/_" class="form-btn">My Team /</router-link>
        </div>
      </div>
      <div class="first noTeam" v-if="!isTeam">
        <div class="token">
          <input type="text" value="" v-model="token" placeholder="Team Token"/>
          <div>
              <button class="btn btn-outline-primary" @click="join">{{join_}}</button>
          </div>
        </div>
        <div class="create"><span>{{or_}} </span><router-link to="/createTeam" style="color: #00c8e3">{{createYourTeam_}}.</router-link></div>
      </div>
      <div class="second" v-if="isRank">
        <h5>Top 10</h5>
        <table class="table rank">
          <thead>
            <tr>
              <th>{{rank_}}</th>
              <th>{{team_}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, index) in rankInfo" :key='index'>
              <td>{{index + 1}}</td>
              <td>{{r}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import { profile, team, joinTeam, logout, uploadLogo } from '@/utils/api.js'
  import { getCookie } from '@/utils/cookies.js'
  import { natural, formatTime } from '@/utils'
  import i18n from '@/i18n'

  export default {
    data () {
      return {
        rankInfo: [],
        result: [],
        token: '',
        solved: 0,
        challengeCount: 0,
        rank: 0,
        total_teams: 0,
        score: 0,
        teamName: '',
        isTeam: false,
        isRank: false,
        flagTitle: '',
        flagURL: '',
        logoUrl: '/logo/_.png',
        date: ''
      }
    },
    computed: {
      ...mapState(['profile', 'v_locale', 'ctfMode']),
      ...mapGetters([]),
      ...i18n.map([
        'location_', 'email_', 'logout_', 'solvedChallenges_', 'name_',
        'score_', 'time_', 'rank_', 'score_', 'solved_', 'total_', 'myTeam_',
        'inputToken_', 'join_', 'or_', 'createTeam_', 'rank_', 'team_', 'createYourTeam_'
      ]),
      percentage () {
        const per = this.solved / this.challengeCount * 100
        return per <= 100 ? per : 0
      }
    },
    methods: {
      ...mapMutations([]),
      ...mapActions([]),
      formatTime,
      init () {
        const name = getCookie('uid')
        if (name && getCookie('sig')) {
          this.profile.name = name
        } else return this.$router.push('/login')

        profile()
          .then((data) => {
            this.profile.email = data.data.email
            this.profile.rating = data.data.rating
            this.profile.uid = data.data.uid
            this.profile.nick = data.data.nick

            this.challengeCount = data.data.total_problems

            this.result = data.data.solved || []
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })

        team('_')
          .then((data) => {
            if (!data || data.err) {
              return null
            }
            this.isTeam = true
            if (data.country) {
              this.flagURL = `/flags/${data.country.toLowerCase()}.png`
            }
            this.teamName = data.name
            this.logoUrl = data.logo || '/logo/_.png'
            this.solved = data.solved.length
            this.score = data.rating
            this.members = data.size || 1
            this.rank = natural(data.rank)
            this.total_teams = natural(data.total_teams)

            return data.tid
          })
          .catch((err) => {
            const [error] = err.message.split(': ')
            if (error === 'notfound') {
              this.isTeam = false
              return
            }
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      },
      submit () {
        const fd = new FormData(this.$refs.imgForm)
        uploadLogo(fd)
          .then((data) => {
            this.logoUrl = data.logo
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      },
      logout,
      join () {
        const token = this.token
        joinTeam(token)
          .then((data) => {
            this.init()
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      }
    },
    created () {
      this.init()
    }
  }
</script>

<style lang='less' scoped>
@title-font: 'OCRAbyBT';
.profile-content {
    padding-top: 60px;
    .left {
        border-right: 1px solid #e3e3e3;
        .first {
            .user-name {
                height: 80px;
                line-height: 80px;
                .name {
                    font-family: @title-font;
                }
            }

            .user-info {
                font-size: 24px;
                color: #00cee3;
                >div>span{
                  font-family: 'OCRAbyBT';
                  color: #fff;
                }
            }
        }
        //first line ends and second start
        .second {
            & > span {
                font-size: 24px;
                color: #00cee3;
                font-family: 'OCRAbyBT';
            }
            ul.table {
                .tr>a>span:not(:last-child) {
                  border-right: 1px solid #e3e3e3;
                }
              a:hover > span {
                color: #00cee3;
              }
                a > span:nth-child(1) {
                  width: 40%;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  vertical-align: top;
                }
                a > span:nth-child(2) {
                width: 22%;

                }
                a > span:nth-child(3) {
                  width: 38%;
                }
            }
        }
    }
    // left ends and right begin
    .right {
        font-family: @title-font;
        .first {
            .team-button {
                .form-btn {
                  display: inline-block;
                  height: 40px;
                  padding: 6px 12px;
                  color: #00cee3;
                  font-size: 18px;
                  background: transparent;
                  border: 1px solid #00cee3;
                  vertical-align: middle;
                  text-decoration: none;
                }
            }
            &.noTeam {
                div.token {
                    height: 40px;
                    display: flex;
                    input {
                      color: #fff;
                      font-family: @title-font;
                      line-height: 30px;
                      height: 38px;
                      padding-left: 0;
                      border: none;
                      outline: none;
                      background: none;
                      border-bottom: 1px solid #fff;
                    }
                    div {
                        .btn {
                          height: 34px;
                          line-height: 34px;
                          border-radius: 0;
                          color: #00c8e3;
                          background: transparent;
                          border: 1px solid #00c8e3;
                        }
                    }
                }
            }
        }
        // first ends and second start
        .second {
            .tr a{
              display: flex;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/themes/dragon/components/profile.vue